import * as THREE from 'three'
import font_helvetiker_regular from '@/assets/fonts/helvetiker_regular.typeface.json';
export const CARD1Web = {
	REVISION: '1',
	Resources: {}
};

export const ThreeExt = {
	REVISION: '1'
};

export const MouseAction = {
	CLICK: 0,
	MOUSEMOVE: 1,
	DBLCLICK:2,
	RIGHTCLICK:3,
	NONE : -1
}

CARD1Web.CoordUtils = {};

CARD1Web.CoordUtils.Coord = function(scene, offset) {
	this.scene = scene;

	// if (offset == undefined) {
		offset = {
			x: 0,
			y: 38,
			z: 0
		};
	// }

	this.offset = offset;
	this.model = new THREE.Object3D();
	this.draw();
}

CARD1Web.CoordUtils.Coord.prototype = {
	constructor: CARD1Web.CoordUtils.Coord,
	draw: function() {
		var zero = this.offset;
		var xEnd = {
			x: this.offset.x + 5000,
			y: this.offset.y,
			z: this.offset.z
		};
		var yEnd = {
			x: this.offset.x,
			y: this.offset.y + 5000,
			z: this.offset.z
		};
		var zEnd = {
			x: this.offset.x,
			y: this.offset.y,
			z: this.offset.z + 5000
		};

		var xStart = {
			x: this.offset.x - 5000,
			y: this.offset.y,
			z: this.offset.z
		};
		var yStart = {
			x: this.offset.x,
			y: this.offset.y - 5000,
			z: this.offset.z
		};
		var zStart = {
			x: this.offset.x,
			y: this.offset.y,
			z: this.offset.z - 5000
		};
		var loader = new THREE.FontLoader();
		var font=loader.parse(font_helvetiker_regular);
		this.createAxis(xStart, xEnd, 0xff0000, "x", font);
		this.createAxis(yStart, yEnd, 0x00ff00, "y", font);
		this.createAxis(zStart, zEnd, 0x0000ff, "z", font);

		this.scene.add(this.model);
	},
	show: function() {
		this.model.visible = true;
	},
	hide: function() {
		this.model.visible = false;
	},
	createAxis: function(first, second, color, label, font) {
		var line = new THREE.Geometry();
		line.vertices.push(new THREE.Vector3(first.x, first.y, first.z));
		line.vertices.push(new THREE.Vector3(second.x, second.y, second.z));
		var colors = [];
		colors[0] = new THREE.Color(color);
		colors[1] = new THREE.Color(color);
		line.colors = colors;

		var material = new THREE.LineDashedMaterial({
			vertexColors: true,
			color: color,
			dashSize: 2,
			gapSize: 2,
			scale: 0.1
		});

		this.model.add(new THREE.Line(line, material));

		var textMaterial = new THREE.MeshBasicMaterial({
			color: color,
			transparent: true,
			opacity: 0.4,
			side: THREE.DoubleSide
		});

		for (let i = 0; i < 10000; i =i+10){
			var textShapes = font.generateShapes((i - 5000).toString() + label, 1);
			var geometry = new THREE.ShapeBufferGeometry( textShapes );
			var text = new THREE.Mesh( geometry, textMaterial );
			text.position.z = (first.z != 0) ? (i + first.z) : 0;
			text.position.y = (first.y != 38) ? (i + first.y) : this.offset.y;
			text.position.x = (first.x != 0) ? (i + first.x) : 0;
			this.model.add(text);	
		}	

		// for (let i = 0; i < 10000; i =i+10){
		// 	var textShapes = font.generateShapes((i - 5000).toString(), 1);
		// 	var geometry = new THREE.ShapeBufferGeometry( textShapes );
		// 	var text = new THREE.Mesh( geometry, textMaterial );
		// 	text.position.z = (first.z != 0) ? (i + first.z) : 0;
		// 	text.position.y = (first.y != 38) ? (i + first.y) : this.offset.y;
		// 	text.position.x = (first.x != 0) ? (i + first.x) : 0;
		// 	this.model.add(text);	
		// }
		
	}
	
}

	CARD1Web.CoordUtils.Helper = function(){

	}

	CARD1Web.CoordUtils.Helper.prototype = {
		constructor: CARD1Web.CoordUtils.Helper,
		//如果没有地形图，需要估算指定点的高度，根据道路坐标找到距离最近的点，
	//计算其最近的道路点并返回其高度作为该点的高度
	getPtHeight(pt, roadStakes){
		//that.sceneManager.geometryManager.getRoadByName获取road
		var minDist = null;
		var minPtVec = null;
		var minItem=null;
		roadStakes.map(item=>{
			var ptVec = new THREE.Vector3(pt.x, item.a3.y, pt.z);
			var dist = item.center.distanceToSquared(ptVec);
			if (minDist == null || minDist > dist) {
				minDist = dist;
				minPtVec = ptVec;
				minItem=item
			}
			else{
				
			}
		});
		return  minPtVec.y;
	},
	
	 leftOfLine(lastPt, thisPt, tgtPt){
      var x1 = lastPt.x;
      var y1 = lastPt.y;
      var x2 = thisPt.x;
      var y2 = thisPt.y;
      var x0 = tgtPt.x;
      var y0 = tgtPt.y;

    return (x2-x1) * (y0-y1) - (y2-y1) * (x0-x1)  >  0  // 左侧 
  },

  getPtStake(pt,roadStakes){
		// 首先找到距离pt最近的点，在计算夹角大小用于判断
		var minDist = null;
		var minPtVec = null;
		var prevStake=new THREE.Vector3();
		var nextStake=new THREE.Vector3();
		var lastIndex=roadStakes.length-1;
		roadStakes.map((item,index)=>{
			var ptVec = new THREE.Vector3(pt.x, item.a3.y, pt.z);
			// 计算该向量到传入的v的平方距离。 如果你只是将该距离和另一个距离进行比较，则应当比较的是距离的平方， 因为它的计算效率会更高一些
			var dist = item.a3.distanceToSquared(ptVec);
			if (minDist == null || minDist > dist) {
				minDist = dist;
				minPtVec = ptVec;
                if(index===0){
                    prevStake=roadStakes[0]
                    nextStake=roadStakes[1]
                }else if(index==lastIndex){
                	prevStake=roadStakes[lastIndex-1];
                	nextStake=roadStakes[lastIndex];
                }else{
                	var prevVector=new THREE.Vector3();
                	    prevVector.copy(roadStakes[index-1].a3);
                	    prevVector.setY(item.a3.y);
                	    prevVector.sub(item.a3);
                	var nextVector=new THREE.Vector3();
                	    nextVector.copy(roadStakes[index+1].a3);
                	    nextVector.setY(item.a3.y);
                	    nextVector.sub(item.a3);

                    var minVector=new THREE.Vector3();
                    minVector.subVectors(minPtVec,item.a3);
                    var prev=prevVector.angleTo(minVector);
                    var next=nextVector.angleTo(minVector);
                    if(prev<=next){
                    	prevStake=roadStakes[index-1];
                    	nextStake=item
                    }else{
                    	prevStake=item;
                    	nextStake=roadStakes[index+1];
                    }
                }
			}
			else{
				
			}
		});
		return {
			prevStake:prevStake,
			nextStake:nextStake
		}
	},
	//合并两个json对象
	merge(jsonbject1, jsonbject2) {
	  var resultJsonObject = {};
	  for (var attr in jsonbject1) {
	    resultJsonObject[attr] = jsonbject1[attr];
	  }
	  for (var attr in jsonbject2) {
	    resultJsonObject[attr] = jsonbject2[attr];
	  }
	  return resultJsonObject;
	},
	//为了避免贴图因为拉伸变形，计算某个矩形表面的纹理坐标变化值
	getUvDeltaByRect(uvImgRatio, a1, a2, a3, a4){
		//uvImgRatio: 贴图的width:height
		//a1,a2,a3,a4代表4个点
		//假设宽填充满且大于长
		var width = a1.distanceTo(a2);
		var height = a1.distanceTo(a3);
		return height * uvImgRatio /width; 
	},

	//快速排序， property为待比较的值
 	fastSort(array, property) {
	  var tmp_array = array.slice(0), result,
	  quickSort = function(arr) {
	　　if (arr.length <= 1) { return arr; }
	　　var pivotIndex = Math.floor(arr.length / 2);
	　　var pivot = arr.splice(pivotIndex, 1)[0];
	　　var left = [];
	　　var right = [];
	　　for (var i = 0; i < arr.length; i++){
	　　　　if (arr[i][property] < pivot[property]) {
	　　　　　　left.push(arr[i]);
	　　　　} else {
	　　　　　　right.push(arr[i]);
	　　　　}
	　　}
	　　return quickSort(left).concat([pivot], quickSort(right));
	  };
	  result = quickSort(tmp_array);
	  return result;
	}
}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/CoordUtils.js